<div
  class="flex flex-col min-h-screen"
  style="margin-top: 1rem; padding: 0 1rem"
  *transloco="let t; prefix: 'providerData'"
>
  <div class="flex items-center justify-center">
    <p-fluid>
      <div class="flex items-center justify-center w-full">
        <div class="w-full max-w-xl rounded-xl">
          <div class="card flex flex-col gap-4 mt-3">
            <div data-testid="provider-registration-title" class="font-semibold text-2xl">
              {{ t('title') }}
            </div>
            <div data-testid="provider-registration-description">
              {{ t('description') }}
            </div>
            <app-provider-data-form
              [inputObject]="providerData()!"
              [isSaving]="saving()"
              (submitOutput)="onSubmit($event)"
            />
          </div>
        </div>
      </div>
    </p-fluid>
  </div>
</div>
